import ScoreboardPanel from "../ScoreboardPanel";
import { scoreboardPanelWrap } from "../scoreboard.css";
import { CommonScoreboardProps } from "../types";
import { integerToMoneyWithCurrency } from "../../../utils/money";
import { usePlosTranslations } from "../../../contexts/PlosTranslationsContext";
const BasicScoreboard = ({
  currencyDivisor,
  elementTypesByPosition,
  proposedElements,
  toSpend,
  isNeedElements,
  isBudgetExceeded,
}: CommonScoreboardProps) => {
  const { scoreboard } = usePlosTranslations();
  return (
    <div className={scoreboardPanelWrap}>
      <ScoreboardPanel
        header={scoreboard.playersSelected}
        value={`${Object.keys(proposedElements).length} / ${
          Object.keys(elementTypesByPosition).length
        }`}
        status={isNeedElements ? "error" : "success"}
      />
      <ScoreboardPanel
        header={scoreboard.bank}
        value={`${toSpend < 0 ? "-" : ""}${integerToMoneyWithCurrency(
          Math.abs(toSpend),
          currencyDivisor,
        )}`}
        status={isBudgetExceeded ? "error" : "success"}
      />
    </div>
  );
};

export default BasicScoreboard;
